import { jsxs as e, Fragment as l, jsx as i } from "react/jsx-runtime";
import s from "./useModal.js";
import r from "./Code.js";
import a from "./Icon.js";
import { M as t } from "./chunks/index-B8d-pCoN.js";
const m = () => {
  const n = s();
  return /* @__PURE__ */ e(l, { children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: "flex font-bold font-secondary gap-2 items-center text-sm uppercase",
        onClick: n.open,
        type: "button",
        children: [
          /* @__PURE__ */ i(a, { name: "keyboard", className: "text-lg" }),
          "Markdown help"
        ]
      }
    ),
    /* @__PURE__ */ e(t, { className: "gap-5", modal: n, children: [
      /* @__PURE__ */ i(t.Heading, { children: "This input supports markdown" }),
      /* @__PURE__ */ e("ul", { className: "flex flex-col gap-1 list-disc px-2 text-left", children: [
        /* @__PURE__ */ i("li", { children: "Separate paragraphs with blank lines" }),
        /* @__PURE__ */ e("li", { children: [
          "Make lists by starting lines with hyphens ",
          /* @__PURE__ */ i(r, { children: "-" }),
          " or numbers",
          " ",
          /* @__PURE__ */ i(r, { children: "1." })
        ] }),
        /* @__PURE__ */ e("li", { children: [
          "Italicize text by surrounding it with single asterisks",
          " ",
          /* @__PURE__ */ i(r, { children: "*" })
        ] }),
        /* @__PURE__ */ e("li", { children: [
          "Make text bold by surrounding it with double asterisks",
          " ",
          /* @__PURE__ */ i(r, { children: "**" })
        ] }),
        /* @__PURE__ */ e("li", { children: [
          "Write inline code snippets by surrounding code with single backticks",
          " ",
          /* @__PURE__ */ i(r, { children: "`" })
        ] }),
        /* @__PURE__ */ e("li", { children: [
          "Create larger code blocks by wrapping code in 3 backticks",
          " ",
          /* @__PURE__ */ i(r, { children: "```" })
        ] }),
        /* @__PURE__ */ e("li", { children: [
          "Create links by wrapping text with square brackets and the URL in parentheses ",
          /* @__PURE__ */ i(r, { children: "[Text](https://link.com)" })
        ] })
      ] })
    ] })
  ] });
};
export {
  m as default
};
